import React, { useState } from 'react';
import { Container, Modal, Form, Button } from 'react-bootstrap';
import './plan.css';
import { useSelector, useDispatch } from 'react-redux';
import useFormValidation from '../../hooks/useFormValidator';
import { additionInfo } from '../../axios/signUp.axios';
import { setTempUser,setLogin,setEscapeBuckSuccess } from '../../actions/signUp.actions';
import { useHistory } from 'react-router-dom';
import { message } from "antd";
import {createRegistrationForEscapeBucks} from '../../axios/signUp.axios'
const AdditionalInfo = (props) => {
    const history = useHistory();
    const tempUser = useSelector(state => state.changeStep.tempuser)
    const product = useSelector((state) => state.product.details);
    const coupon = useSelector((state) => state.coupon);
    const dispatch = useDispatch();
    const showError = (inputName) => {
        return validationReport.inputName && !validationReport.inputName.isValid ? <small>{validationReport.inputName.errorMessage} </small> : ""
    }
    // console.log(tempUser)

    const [input, setInput] = useState({
        id: tempUser.id,
        firstName: "",
        lastName: "",
        phone: "",
        address: "",
        city: "",
        country: "",
        state: "",
        zipCode: "",
        ipAddress: (localStorage.getItem('clientIp')) ? localStorage.getItem('clientIp') : '',
    })
    const [validationReport, validate] = useFormValidation()
    const change = async (wizard) => {
        let totalName = `${input?.firstName} ${input?.lastName}`;
        let checkName = totalName?.trim().toLowerCase().replace(/\s+/g, '');
        if (checkName != 'lamichaelharris' && input?.phone != "8595362899") {

            props.loader(true)
            await additionInfo(input)
                .then(async(res) => {
                    if (res.data.status) {
                        let temp = {
                            ...tempUser,
                            ...input
                        }
                        dispatch(setTempUser(temp))
                        if (product && product.isEscapeBuckPlan) {
                           await escapeBucksSignupSubmit();
                        } else {
                            props.changeWizard(wizard)
                        }
                    } else {
                        props.notify(res.data.message, false)
                    }
                    props.loader(false)
                })
                .catch(err => {
                    props.loader(false)
                })
        } else {
            message.error("Sorry, You don't have access");
        }


    }

    const escapeBucksSignupSubmit = async() => {
        console.log(product,"ff",coupon)
        let temp = {
                userDetails: tempUser,
                amount: product.price,
                price: product.product_id,
                coupon: product.coupon,
                priceObject: product.priceObject
            }
            props.loader(true)
            await createRegistrationForEscapeBucks(temp)
            .then(res => {
                if (res.data.status) {

                    // dispatch(setTempUser(temp))
                    dispatch(setEscapeBuckSuccess(res.data.data.user))
                    dispatch(setLogin(res.data.data.dashboardURL))
                    props.notify("Registration was successfull", true)
                    props.changeWizard("escapebuckSuccess")

                }
                else {
                    props.notify("Registration was not successfull. Error: " + res.data.message)
                    // message.error("Payment was not successfull. Error: "+ res.data.message)
                }
                props.loader(false)
            })
            .catch(err => {
                props.notify("Registration was not successfull. Error: " + err.message, false)
                props.loader(false)
            })
    }

    const handleChange = (event) => {

        let rules = JSON.parse(event.target.dataset.rules)
        validate(event.target.value, rules, event.target.name)
        setInput({ ...input, [event.target.name]: event.target.value })


    }
    return (
        <div className='sign_up_partts'>
            <h3>2. Additional Info</h3>
            <p>hello {tempUser.email} Please add some more details...</p>
            <Form>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>First Name*</Form.Label>
                    <Form.Control
                        type="text"
                        name="firstName"
                        placeholder="Enter First Name"
                        data-rules={JSON.stringify({
                            required: true
                        })}
                        onChange={(event) => { handleChange(event) }}
                        className='sign_email' />
                    {
                        validationReport.firstName && !validationReport.firstName.isValid ? <small className='text-danger'>{validationReport.firstName.errorMessage} </small> : ""
                    }

                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Last Name*</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter Last Name"
                        className='sign_email'
                        name="lastName"
                        data-rules={JSON.stringify({
                            required: true
                        })}
                        onChange={(event) => {
                            handleChange(event)
                        }}
                        value={input.lastName}
                    />
                    {
                        validationReport.lastName && !validationReport.lastName.isValid ? <small className='text-danger'>{validationReport.lastName.errorMessage} </small> : ""
                    }
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Phone*</Form.Label>
                    <Form.Control
                        type="tel"
                        placeholder="Enter Phone"
                        className='sign_email'
                        name="phone"
                        value={input.phone}
                        data-rules={JSON.stringify({
                            required: true,
                            number: true
                        })}
                        onChange={(event) => { handleChange(event) }}
                    />
                    {
                        validationReport.phone && !validationReport.phone.isValid ? <small className='text-danger'>{validationReport.phone.errorMessage} </small> : ""
                    }
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Address*</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter Address"
                        className='sign_email'
                        name="address"
                        value={input.address}
                        data-rules={JSON.stringify({
                            required: true
                        })}
                        onChange={(event) => { handleChange(event) }}

                    />
                    {
                        validationReport.address && !validationReport.address.isValid ? <small className='text-danger'>{validationReport.address.errorMessage} </small> : ""
                    }
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>City*</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter City"
                        className='sign_email'
                        name="city"
                        value={input.city}
                        data-rules={JSON.stringify({
                            required: true
                        })}
                        onChange={(event) => { handleChange(event) }}
                    />
                    {
                        validationReport.city && !validationReport.city.isValid ? <small className='text-danger'>{validationReport.city.errorMessage} </small> : ""
                    }
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>State*</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter State"
                        className='sign_email'
                        name="state"
                        value={input.state}
                        data-rules={JSON.stringify({
                            required: true
                        })}
                        onChange={(event) => { handleChange(event) }}

                    />
                    {
                        validationReport.state && !validationReport.state.isValid ? <small className='text-danger'>{validationReport.state.errorMessage} </small> : ""
                    }
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Zip Code*</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter Zip Code"
                        className='sign_email'
                        name="zipCode"
                        value={input.zipCode}
                        data-rules={JSON.stringify({
                            required: true
                        })}
                        onChange={(event) => { handleChange(event) }}

                    />
                    {
                        validationReport.zipCode && !validationReport.zipCode.isValid ? <small className='text-danger'>{validationReport.zipCode.errorMessage} </small> : ""
                    }
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Country*</Form.Label>
                    <Form.Control
                        as="select"
                        className="modal_t_field"
                        name='country'
                        value={input.country}
                        data-rules={JSON.stringify({
                            required: true
                        })}
                        onChange={(event) => { handleChange(event) }}
                    >

                        <option value="00">Select country</option>
                        <option value="AF">Afghanistan</option>
                        <option value="AX">Åland Islands</option>
                        <option value="AL">Albania</option>
                        <option value="DZ">Algeria</option>
                        <option value="AS">American Samoa</option>
                        <option value="AD">Andorra</option>
                        <option value="AO">Angola</option>
                        <option value="AI">Anguilla</option>
                        <option value="AQ">Antarctica</option>
                        <option value="AG">Antigua and Barbuda</option>
                        <option value="AR">Argentina</option>
                        <option value="AM">Armenia</option>
                        <option value="AW">Aruba</option>
                        <option value="AU">Australia</option>
                        <option value="AT">Austria</option>
                        <option value="AZ">Azerbaijan</option>
                        <option value="BS">Bahamas</option>
                        <option value="BH">Bahrain</option>
                        <option value="BD">Bangladesh</option>
                        <option value="BB">Barbados</option>
                        <option value="BY">Belarus</option>
                        <option value="BE">Belgium</option>
                        <option value="BZ">Belize</option>
                        <option value="BJ">Benin</option>
                        <option value="BM">Bermuda</option>
                        <option value="BT">Bhutan</option>
                        <option value="BO">Bolivia, Plurinational State of</option>
                        <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                        <option value="BA">Bosnia and Herzegovina</option>
                        <option value="BW">Botswana</option>
                        <option value="BV">Bouvet Island</option>
                        <option value="BR">Brazil</option>
                        <option value="IO">British Indian Ocean Territory</option>
                        <option value="BN">Brunei Darussalam</option>
                        <option value="BG">Bulgaria</option>
                        <option value="BF">Burkina Faso</option>
                        <option value="BI">Burundi</option>
                        <option value="KH">Cambodia</option>
                        <option value="CM">Cameroon</option>
                        <option value="CA">Canada</option>
                        <option value="CV">Cape Verde</option>
                        <option value="KY">Cayman Islands</option>
                        <option value="CF">Central African Republic</option>
                        <option value="TD">Chad</option>
                        <option value="CL">Chile</option>
                        <option value="CN">China</option>
                        <option value="CX">Christmas Island</option>
                        <option value="CC">Cocos (Keeling) Islands</option>
                        <option value="CO">Colombia</option>
                        <option value="KM">Comoros</option>
                        <option value="CG">Congo</option>
                        <option value="CD">Congo, the Democratic Republic of the</option>
                        <option value="CK">Cook Islands</option>
                        <option value="CR">Costa Rica</option>
                        <option value="CI">Côte d'Ivoire</option>
                        <option value="HR">Croatia</option>
                        <option value="CU">Cuba</option>
                        <option value="CW">Curaçao</option>
                        <option value="CY">Cyprus</option>
                        <option value="CZ">Czech Republic</option>
                        <option value="DK">Denmark</option>
                        <option value="DJ">Djibouti</option>
                        <option value="DM">Dominica</option>
                        <option value="DO">Dominican Republic</option>
                        <option value="EC">Ecuador</option>
                        <option value="EG">Egypt</option>
                        <option value="SV">El Salvador</option>
                        <option value="GQ">Equatorial Guinea</option>
                        <option value="ER">Eritrea</option>
                        <option value="EE">Estonia</option>
                        <option value="ET">Ethiopia</option>
                        <option value="FK">Falkland Islands (Malvinas)</option>
                        <option value="FO">Faroe Islands</option>
                        <option value="FJ">Fiji</option>
                        <option value="FI">Finland</option>
                        <option value="FR">France</option>
                        <option value="GF">French Guiana</option>
                        <option value="PF">French Polynesia</option>
                        <option value="TF">French Southern Territories</option>
                        <option value="GA">Gabon</option>
                        <option value="GM">Gambia</option>
                        <option value="GE">Georgia</option>
                        <option value="DE">Germany</option>
                        <option value="GH">Ghana</option>
                        <option value="GI">Gibraltar</option>
                        <option value="GR">Greece</option>
                        <option value="GL">Greenland</option>
                        <option value="GD">Grenada</option>
                        <option value="GP">Guadeloupe</option>
                        <option value="GU">Guam</option>
                        <option value="GT">Guatemala</option>
                        <option value="GG">Guernsey</option>
                        <option value="GN">Guinea</option>
                        <option value="GW">Guinea-Bissau</option>
                        <option value="GY">Guyana</option>
                        <option value="HT">Haiti</option>
                        <option value="HM">Heard Island and McDonald Islands</option>
                        <option value="VA">Holy See (Vatican City State)</option>
                        <option value="HN">Honduras</option>
                        <option value="HK">Hong Kong</option>
                        <option value="HU">Hungary</option>
                        <option value="IS">Iceland</option>
                        <option value="IN">India</option>
                        <option value="ID">Indonesia</option>
                        <option value="IR">Iran, Islamic Republic of</option>
                        <option value="IQ">Iraq</option>
                        <option value="IE">Ireland</option>
                        <option value="IM">Isle of Man</option>
                        <option value="IL">Israel</option>
                        <option value="IT">Italy</option>
                        <option value="JM">Jamaica</option>
                        <option value="JP">Japan</option>
                        <option value="JE">Jersey</option>
                        <option value="JO">Jordan</option>
                        <option value="KZ">Kazakhstan</option>
                        <option value="KE">Kenya</option>
                        <option value="KI">Kiribati</option>
                        <option value="KP">Korea, Democratic People's Republic of</option>
                        <option value="KR">Korea, Republic of</option>
                        <option value="KW">Kuwait</option>
                        <option value="KG">Kyrgyzstan</option>
                        <option value="LA">Lao People's Democratic Republic</option>
                        <option value="LV">Latvia</option>
                        <option value="LB">Lebanon</option>
                        <option value="LS">Lesotho</option>
                        <option value="LR">Liberia</option>
                        <option value="LY">Libya</option>
                        <option value="LI">Liechtenstein</option>
                        <option value="LT">Lithuania</option>
                        <option value="LU">Luxembourg</option>
                        <option value="MO">Macao</option>
                        <option value="MK">Macedonia, the former Yugoslav Republic of</option>
                        <option value="MG">Madagascar</option>
                        <option value="MW">Malawi</option>
                        <option value="MY">Malaysia</option>
                        <option value="MV">Maldives</option>
                        <option value="ML">Mali</option>
                        <option value="MT">Malta</option>
                        <option value="MH">Marshall Islands</option>
                        <option value="MQ">Martinique</option>
                        <option value="MR">Mauritania</option>
                        <option value="MU">Mauritius</option>
                        <option value="YT">Mayotte</option>
                        <option value="MX">Mexico</option>
                        <option value="FM">Micronesia, Federated States of</option>
                        <option value="MD">Moldova, Republic of</option>
                        <option value="MC">Monaco</option>
                        <option value="MN">Mongolia</option>
                        <option value="ME">Montenegro</option>
                        <option value="MS">Montserrat</option>
                        <option value="MA">Morocco</option>
                        <option value="MZ">Mozambique</option>
                        <option value="MM">Myanmar</option>
                        <option value="NA">Namibia</option>
                        <option value="NR">Nauru</option>
                        <option value="NP">Nepal</option>
                        <option value="NL">Netherlands</option>
                        <option value="NC">New Caledonia</option>
                        <option value="NZ">New Zealand</option>
                        <option value="NI">Nicaragua</option>
                        <option value="NE">Niger</option>
                        <option value="NG">Nigeria</option>
                        <option value="NU">Niue</option>
                        <option value="NF">Norfolk Island</option>
                        <option value="MP">Northern Mariana Islands</option>
                        <option value="NO">Norway</option>
                        <option value="OM">Oman</option>
                        <option value="PK">Pakistan</option>
                        <option value="PW">Palau</option>
                        <option value="PS">Palestinian Territory, Occupied</option>
                        <option value="PA">Panama</option>
                        <option value="PG">Papua New Guinea</option>
                        <option value="PY">Paraguay</option>
                        <option value="PE">Peru</option>
                        <option value="PH">Philippines</option>
                        <option value="PN">Pitcairn</option>
                        <option value="PL">Poland</option>
                        <option value="PT">Portugal</option>
                        <option value="PR">Puerto Rico</option>
                        <option value="QA">Qatar</option>
                        <option value="RE">Réunion</option>
                        <option value="RO">Romania</option>
                        <option value="RU">Russian Federation</option>
                        <option value="RW">Rwanda</option>
                        <option value="BL">Saint Barthélemy</option>
                        <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
                        <option value="KN">Saint Kitts and Nevis</option>
                        <option value="LC">Saint Lucia</option>
                        <option value="MF">Saint Martin (French part)</option>
                        <option value="PM">Saint Pierre and Miquelon</option>
                        <option value="VC">Saint Vincent and the Grenadines</option>
                        <option value="WS">Samoa</option>
                        <option value="SM">San Marino</option>
                        <option value="ST">Sao Tome and Principe</option>
                        <option value="SA">Saudi Arabia</option>
                        <option value="SN">Senegal</option>
                        <option value="RS">Serbia</option>
                        <option value="SC">Seychelles</option>
                        <option value="SL">Sierra Leone</option>
                        <option value="SG">Singapore</option>
                        <option value="SX">Sint Maarten (Dutch part)</option>
                        <option value="SK">Slovakia</option>
                        <option value="SI">Slovenia</option>
                        <option value="SB">Solomon Islands</option>
                        <option value="SO">Somalia</option>
                        <option value="ZA">South Africa</option>
                        <option value="GS">South Georgia and the South Sandwich Islands</option>
                        <option value="SS">South Sudan</option>
                        <option value="ES">Spain</option>
                        <option value="LK">Sri Lanka</option>
                        <option value="SD">Sudan</option>
                        <option value="SR">Suriname</option>
                        <option value="SJ">Svalbard and Jan Mayen</option>
                        <option value="SZ">Swaziland</option>
                        <option value="SE">Sweden</option>
                        <option value="CH">Switzerland</option>
                        <option value="SY">Syrian Arab Republic</option>
                        <option value="TW">Taiwan, Province of China</option>
                        <option value="TJ">Tajikistan</option>
                        <option value="TZ">Tanzania, United Republic of</option>
                        <option value="TH">Thailand</option>
                        <option value="TL">Timor-Leste</option>
                        <option value="TG">Togo</option>
                        <option value="TK">Tokelau</option>
                        <option value="TO">Tonga</option>
                        <option value="TT">Trinidad and Tobago</option>
                        <option value="TN">Tunisia</option>
                        <option value="TR">Turkey</option>
                        <option value="TM">Turkmenistan</option>
                        <option value="TC">Turks and Caicos Islands</option>
                        <option value="TV">Tuvalu</option>
                        <option value="UG">Uganda</option>
                        <option value="UA">Ukraine</option>
                        <option value="AE">United Arab Emirates</option>
                        <option value="GB">United Kingdom</option>
                        <option value="US">United States</option>
                        <option value="UM">United States Minor Outlying Islands</option>
                        <option value="UY">Uruguay</option>
                        <option value="UZ">Uzbekistan</option>
                        <option value="VU">Vanuatu</option>
                        <option value="VE">Venezuela, Bolivarian Republic of</option>
                        <option value="VN">Viet Nam</option>
                        <option value="VG">Virgin Islands, British</option>
                        <option value="VI">Virgin Islands, U.S.</option>
                        <option value="WF">Wallis and Futuna</option>
                        <option value="EH">Western Sahara</option>
                        <option value="YE">Yemen</option>
                        <option value="ZM">Zambia</option>
                        <option value="ZW">Zimbabwe</option>
                    </Form.Control>
                    {
                        validationReport.country && !validationReport.country.isValid ? <small className='text-danger'>{validationReport.country.errorMessage} </small> : ""
                    }
                </Form.Group>
                <div className='sign_submit'>
                    <Button variant="primary" type="button" onClick={() => { change("payment") }}>
                        Next
                    </Button >
                </div>
            </Form>
        </div>
    );
};

export default AdditionalInfo;